import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { MessageSquare, ArrowRight, Loader2 } from "lucide-react";
import { LOGIN, REGISTER } from "@/constants/testIds";

export default function AuthPage() {
  const { user, login, register, error, setError } = useAuth();
  const [tab, setTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", confirm: "" });
  const nav = useNavigate();

  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let ok = false;
    if (tab === "login") ok = await login(form.email, form.password);
    else {
      if (form.password !== form.confirm) { setError("As senhas não coincidem"); setLoading(false); return; }
      ok = await register(form.email, form.password, form.name);
    }
    setLoading(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 grid place-items-center p-6 relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-emerald-500/10 blur-3xl" />
      </div>
      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src="/gatinho.png" alt="Acompanhamento Vendas" className="w-12 h-12 shrink-0 object-contain" />
          <div>
            <div className="font-bold text-2xl leading-tight">Acompanhamento Vendas</div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">ORGANIZE • ACOMPANHE • CONQUISTE</div>
          </div>
        </div>

        <Card className="bg-[#111827] border-slate-800/80 p-6 shadow-2xl">
          <Tabs value={tab} onValueChange={(v) => { setTab(v); setError(""); }}>
            <TabsList className="grid w-full grid-cols-2 bg-slate-800/50">
              <TabsTrigger value="login" data-testid="login-tab">Entrar</TabsTrigger>
              <TabsTrigger value="register" data-testid="register-tab">Criar Conta</TabsTrigger>
            </TabsList>

            <form onSubmit={submit} className="mt-6 space-y-4">
              {tab === "register" && (
                <div className="space-y-1.5">
                  <Label htmlFor="name" className="text-xs uppercase tracking-wider text-slate-400">Nome</Label>
                  <Input id="name" value={form.name} required onChange={(e) => setForm({ ...form, name: e.target.value })}
                         data-testid={REGISTER.nameInput} className="bg-slate-900/60 border-slate-800" />
                </div>
              )}
              <div className="space-y-1.5">
                <Label htmlFor="email" className="text-xs uppercase tracking-wider text-slate-400">Email</Label>
                <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                       data-testid={tab === "login" ? LOGIN.emailInput : REGISTER.emailInput} className="bg-slate-900/60 border-slate-800" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="password" className="text-xs uppercase tracking-wider text-slate-400">Senha</Label>
                <Input id="password" type="password" required minLength={6} value={form.password}
                       onChange={(e) => setForm({ ...form, password: e.target.value })}
                       data-testid={tab === "login" ? LOGIN.passwordInput : REGISTER.passwordInput} className="bg-slate-900/60 border-slate-800" />
              </div>
              {tab === "register" && (
                <div className="space-y-1.5">
                  <Label htmlFor="confirm" className="text-xs uppercase tracking-wider text-slate-400">Confirmar Senha</Label>
                  <Input id="confirm" type="password" required value={form.confirm}
                         onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                         data-testid={REGISTER.passwordConfirmInput} className="bg-slate-900/60 border-slate-800" />
                </div>
              )}

              {error && (
                <div className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2">{error}</div>
              )}

              <Button type="submit" disabled={loading}
                      className="w-full bg-emerald-500 hover:bg-emerald-600 text-white active:scale-[0.98] transition-transform"
                      data-testid={tab === "login" ? LOGIN.submitButton : REGISTER.submitButton}>
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                {tab === "login" ? "Entrar" : "Criar conta"}
                {!loading && <ArrowRight className="w-4 h-4 ml-2" />}
              </Button>

              {tab === "login" && (
                <div className="text-center">
                  <a href="/forgot-password" data-testid={LOGIN.forgotPasswordLink}
                     className="text-xs text-slate-400 hover:text-emerald-400 font-mono uppercase tracking-wider">
                    Esqueci minha senha
                  </a>
                </div>
              )}
            </form>
          </Tabs>
        </Card>

        <p className="text-center text-xs text-slate-500 mt-6 font-mono">
         
        </p>
      </div>
    </div>
  );
}
